import React,{useEffect,useState} from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom"
import Home from './Components/Home'
import Signup from './Components/Signup' 
import Hello from './Components/Hello'
import Login from './Components/Login'
import { auth } from './Components/Firebase'
import Wishlist from './Components/Wishlist'
import Discussion from './Components/Discussion'

const App = () => {
  const [presentUser,setPresentUser]=useState(null);
  useEffect(()=>{
    auth.onAuthStateChanged(user=>{
      if(user){
      setPresentUser({
        uid:user.uid,
        email:user.email
      })
    }
    else{
        setPresentUser(null);
    }
  })
  },[])
  return (
    <div>
      <Router>
        <Routes>
        <Route path='/' element={<Hello/>}/>
        <Route  path='/signup' element={<Signup/>}/>
        <Route  path='/login' element={<Login/>}/>
        <Route  path='/wishlist' element={<Wishlist presentUser={presentUser}/>}/>
        <Route  path='/discussions' element={<Discussion presentUser={presentUser}/>}/>
        <Route path='/home' element={presentUser ? (<Home presentUser={presentUser}/>) : <Login/> }/>
        </Routes>
      </Router>
    </div>
  )
}

export default App
